module.exports = __webpack_public_path__ + "media/audio56.e1bf5dfd.mp3";